import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = ["src", "alt"]
const _hoisted_3 = { class: "break-all" }

import { DocumentIcon } from '@heroicons/vue/24/solid'


export default /*@__PURE__*/_defineComponent({
  __name: 'UrlPreview',
  props: {
    url: {},
    name: {}
  },
  async setup(__props: any) {

let __temp: any, __restore: any

const props = __props

const fileInfo = (
  ([__temp,__restore] = _withAsyncContext(() => fetch(props.url, { method: 'HEAD' }))),
  __temp = await __temp,
  __restore(),
  __temp
);
const contentType = fileInfo.headers.get("content-type");
const contentSize = Math.round(Number(fileInfo.headers.get("content-length")) / 1024 / 1024 * 100) / 100;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    href: _ctx.url,
    target: "_blank",
    class: "box"
  }, [
    (_unref(contentType).startsWith('image/'))
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _ctx.url,
          alt: _ctx.name
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    (_unref(contentType) === 'application/pdf')
      ? (_openBlock(), _createBlock(_unref(DocumentIcon), {
          key: 1,
          class: "pdf"
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createTextVNode(_toDisplayString(_ctx.name) + " ", 1),
      _createElementVNode("span", { class: "opacity-80" }, "(" + _toDisplayString(contentSize) + " MiB)")
    ])
  ], 8, _hoisted_1))
}
}

})